import styled from '@emotion/styled';
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Modal, BodyTextMedium as Description } from '@modernhealth/vital-components';

const DescriptionWrapper = styled.div({
    display: 'flex',
    flexDirection: 'column',
});

export enum WellbeingReportSummaryModalTestID {
    Modal = 'WellbeingReportSummaryModalTestID.Modal',
    Button = 'WellbeingReportSummaryModalTestID.Button',
}

interface Props {
    visible: boolean;
    onCancel: () => void;
}

export const WellbeingReportSummaryModal: React.FC<Props> = ({ visible, onCancel }) => {
    const { t } = useTranslation();

    return (
        <Modal
            isVisible={visible}
            onCloseButtonClick={onCancel}
            maxWidth={558}
            title={t('assessments:wellbeing_report.well_being_summary_modal.title')}
        >
            <DescriptionWrapper>
                <Description marginBottom={16}>
                    {t('assessments:wellbeing_report.well_being_summary_modal.description_one')}
                </Description>
                <Description marginBottom={28}>
                    <Trans
                        t={t}
                        ns="assessments"
                        i18nKey="wellbeing_report.well_being_summary_modal.description_two"
                        components={{
                            bold: <strong />,
                        }}
                    />
                </Description>
                <Description>
                    {t('assessments:wellbeing_report.well_being_summary_modal.description_three')}
                </Description>
            </DescriptionWrapper>
        </Modal>
    );
};
